import {companyLogos} from 'content/home-page'
import React from 'react'
import MarqueeComponent from 'react-fast-marquee'
import allinoneImg from 'assets/icons/client-icons/allinone.webp'
import allinone2Img from 'assets/icons/client-icons/allinone2.webp'

import classes from './style.module.css'
import Image from 'next/image'

export default function Client() {
  return (
    <div className={classes.container}>
      <h4 className={classes.logoTitle}>
        {' '}
        <span style={{color: 'var(--blue-1)'}}>
          Top SMBs and Household names trust ZenAdmin for
        </span>{' '}
        IT Management along the employee lifecycle
      </h4>
      <div className={classes.companyLogoContainer}>
        {companyLogos.map((info, idx) => (
          <Image
            key={idx}
            style={{minHeight: `${info.height}px`, minWidth: `${info.width}px`}}
            className={classes.companyImg}
            src={info.img.src}
            alt={info.alt}
            width={info.width}
            height={info.height}
          />
        ))}
      </div>
      <div className={classes.marquee} id="marquee">
        <MarqueeComponent speed={50}>
          <>
            <Image
              priority
              src={allinoneImg}
              alt="Brand logos"
              width={1561}
              height={41}
              className={classes.marqueeImage}
            />
            <Image
              priority
              src={allinone2Img}
              alt="Brand logos"
              width={1620}
              height={34}
              className={classes.marqueeImage}
            />
          </>
        </MarqueeComponent>
      </div>
    </div>
  )
}
